import { ApiRequests } from '@tableau/data-catalog-client-components';
import * as React from 'react';
import * as _ from 'underscore';

import { SiteUrlsProps } from '../../app/selectors/SiteUrlsSelectors';
import { ModifiedDateMetadata, OwnerMetadata } from '../../app/spaces/Header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '../../app/spaces/Header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '../../app/spaces/Header/SpaceHeader';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';
import { IPublishedConnectionActions } from '../../ts/ServerApi/types/IPublishedConnectionActions';

export interface PublishedConnectionSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'publishedConnection'>;
  readonly availableActions: IPublishedConnectionActions;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}

export function PublishedConnectionSpaceHeader(props: PublishedConnectionSpaceHeaderProps): JSX.Element {
  return (
    <ConnectedSpaceHeader
      item={props.item}
      availableActions={props.availableActions}
      nameRowIcons={
        <React.Fragment>
          {FavoriteToggleWithCountsIcon({
            item: props.item,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          })}
          {ActionsMenuIcon(props.item)}
        </React.Fragment>
      }
      metadataRow={
        <React.Fragment>
          {OwnerMetadata(props.item.owner, props.urls)}
          {ModifiedDateMetadata(props.item.updatedAt)}
        </React.Fragment>
      }
    />
  );
}
